import { eventStatusToBadgeVariant, getEventMainRoute, getEventStatusLabel } from '@/event/event';
import { externalEventEventStatusToBadgeVariant, getExternalEventLink } from '@/external_event/externalEvent';
import { $t } from '@/plugins/fluent';
import { getProjectLink, getProjectStatusLabel, projectStatusToBadgeVariant } from '@/project/project';
import { AllocationGroupType } from '../AllocationSelectionPanel/AllocationSelectionPanel.types';
import { BadgeVariant } from '../Badge/Badge.vue';

export function getAllocationGroupRoute(type: AllocationGroupType, objectId: string) {
    switch (type) {
        case 'Event':
            return getEventMainRoute(objectId);
        case 'Project':
            return getProjectLink(objectId);
        case 'ExternalEvent':
            return getExternalEventLink(objectId);
    }
}

export function getAllocationGroupStatusLabel(type: AllocationGroupType, status: string) {
    switch (type) {
        case 'Event':
            return getEventStatusLabel(status);
        case 'Project':
            return getProjectStatusLabel(status);
        case 'ExternalEvent':
            return $t('external-event-event-status', { status });
    }
}

export function getAllocationGroupStatusColor(type: AllocationGroupType, status: string): BadgeVariant {
    switch (type) {
        case 'Event':
            return eventStatusToBadgeVariant(status);
        case 'Project':
            return projectStatusToBadgeVariant(status);
        case 'ExternalEvent':
            return externalEventEventStatusToBadgeVariant(status);
    }
}
